import React from 'react';
import { motion } from 'framer-motion';

export default function IndicacaoSection() {
  const options = [
    {
      title: 'Postos de Combustíveis',
      image: '/images/indicacao-posto.jpg',
      items: [
        'Distribuição de etanol hidratado e anidro',
        'Logística otimizada e rastreamento em tempo real',
      ],
    },
    {
      title: 'Indústrias',
      image: '/images/indicacao-industria.jpg',
      items: [
        'Setor farmacêutico e cosméticos',
        'Fabricação de solventes e tintas',
        'Produção de aromatizantes e fragrâncias',
        'Linhas de limpeza e higiene',
        'Indústria de bebidas e embalagens',
      ],
    },
  ];

  return (
    <section className="relative py-20 px-6 bg-gradient-to-br from-green-100 via-green-50 to-white overflow-hidden">
      {/* Top Wave Divider */}
      <div className="absolute inset-x-0 top-0 pointer-events-none">
        <svg className="w-full h-16 block" viewBox="0 0 1440 54" xmlns="http://www.w3.org/2000/svg">
          <path fill="#DCFCE7" d="M0,0 C480,54 960,0 1440,54 L1440,54 L0,54 Z" />
        </svg>
      </div>

      {/* Title and Subtitle */}
      <div className="relative max-w-6xl mx-auto text-center mb-12">
        <motion.h2
          className="text-4xl md:text-5xl font-extrabold text-green-800 mb-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          Para Quem É Indicado?
        </motion.h2>
        <motion.p
          className="text-lg text-green-600 max-w-2xl mx-auto leading-relaxed"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.1, duration: 0.5 }}
        >
          Atendemos diversos segmentos que exigem qualidade, eficiência e suporte especializado. Conheça as principais aplicações dos nossos produtos.
        </motion.p>
      </div>

      {/* Cards Grid */}
      <div className="relative max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10">
        {options.map((opt, idx) => (
          <motion.div
            key={opt.title}
            className="bg-white rounded-2xl shadow-lg overflow-hidden transition-transform duration-150"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 + idx * 0.2, duration: 0.5 }}
            whileHover={{ scale: 1.03, boxShadow: '0 12px 40px rgba(0,0,0,0.1)' }}
          >
            <div className="h-56 overflow-hidden">
              <img
                src={opt.image}
                alt={opt.title}
                className="w-full h-full object-cover object-center transition-transform duration-300 hover:scale-105"
              />
            </div>
            <div className="p-6">
              <h3 className="text-2xl font-semibold text-green-800 mb-4">
                {opt.title}
              </h3>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                {opt.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Bottom Wave Divider */}
      <div className="absolute inset-x-0 bottom-0 pointer-events-none">
        <svg className="w-full h-16 block rotate-180" viewBox="0 0 1440 54" xmlns="http://www.w3.org/2000/svg">
          <path fill="#DCFCE7" d="M0,0 C480,54 960,0 1440,54 L1440,54 L0,54 Z" />
        </svg>
      </div>
    </section>
  );
}
